import { SampleNavHeightPx } from 'constants/navBar';
import React from 'react';
import { Box } from '@landr/maestro';
import { cva } from '@landr/styled-system/css';
import { Token, token } from '@landr/styled-system/tokens';
import { useLocation } from 'react-router-dom';
import { RoutePaths } from 'types/enums';

const gradientStyles = cva({
    base: {
        position: 'absolute',
        top: 'var(--gradient-top)',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundImage: `
            {assets.noiseTexture}, 
            radial-gradient(
                63.97% 104.48% at 58.35% 21.58%, 
                var(--gradient-color, {colors.lightings.neutral.start}) 40%, 
                {colors.lightings.neutral.end} 100%)
            `,
        maskImage: '{gradients.scrimToBottomMask}',
    },
    variants: {
        height: {
            default: { height: '350px' },
            medium: { height: '450px' },
            long: { height: '650px' },
            ['3/4']: { height: '75vh', zIndex: -1 },
        },
        opacity: {
            subtle: { opacity: 'var(--opacity-subtle)' },
            overlay: { opacity: 'var(--opacity-overlay)' },
        },
    },
    defaultVariants: {
        height: 'default',
        opacity: 'subtle',
    },
});

const routePathForLongGradient = [
    RoutePaths.Packs,
    RoutePaths.Artists,
    RoutePaths.UserCollections,
    RoutePaths.Genres,
    RoutePaths.Instruments,
    RoutePaths.Labels,
    RoutePaths.Collections,
    RoutePaths.Charts,
    RoutePaths.Exclusives,
    RoutePaths.QuickPicks,
    RoutePaths.KeyBpmFinder,
    RoutePaths.CreatorBeatMaker,
];

const getGradientHeight = (pathname: string) => {
    if (pathname === '/') {
        return 'long';
    } else if (
        routePathForLongGradient.some((route) => pathname.includes(route))
    ) {
        return 'medium';
    } else {
        return 'default';
    }
};

export const Gradient = ({
    color,
    opacity,
    height,
}: {
    color: string | Token;
    opacity: 'subtle' | 'overlay';
    height?: 'default' | 'medium' | 'long' | '3/4';
}) => {
    const { pathname } = useLocation();
    const gradientHeight = height ?? getGradientHeight(pathname);

    return (
        <Box
            className={gradientStyles({ height: gradientHeight, opacity })}
            style={
                {
                    '--gradient-color': token(color as Token) ?? color,
                    '--gradient-top': `-${SampleNavHeightPx + 160}px`,
                } as React.CSSProperties
            }
        />
    );
};

export default Gradient;
